export const AIRTABLE_BASE = 'app0WMHWcSsMMiWMW';
export const AIRTABLE_APIKEY = 'keyajelld9aZoAKi8';

export const SHOPIFY_TOKEN = '6bf3635ed613b381c8aa04ee9340ac26';
export const SHOPIFY_DOMAIN = 'meta-pro-labs.myshopify.com';

export const AIRTABLE_URL = `https://api.airtable.com/v0/${AIRTABLE_BASE}`;


